import { TypographyT7 } from '@picsart/design-system/foundation/typography';

import { useEffect, useRef, useState } from 'react';

import cls from 'classnames';

import {
  Button,
  ButtonSizeLG,
  ButtonSkinTertiary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import { Text } from '@picsart/design-system/components/Text';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

import { useTranslator } from '@picsart/rc/services/localization';
import { RelatedCategoriesTargetModel } from 'templates/types';
import RelatedCategory from './RelatedCategory';
import { TWO_LINES_HEIGHT } from './constants';

import { useRelatedCategoriesStyles } from './styles';

export default function TemplatesRelatedCategories({
  related,
}: {
  related: Array<RelatedCategoriesTargetModel>;
}) {
  const translate = useTranslator();
  const classes = useRelatedCategoriesStyles();
  const [loaded, setLoaded] = useState(false);
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      listRef.current.clientHeight < TWO_LINES_HEIGHT && setLoaded(true);
    }
  }, []);

  return (
    <div className={classes.root} data-pulse-section="browse-more-categories">
      <Text className={classes.header} size={TypographyT7} weight={FontWeights.semibold}>
        Browse more categories
      </Text>

      <div className={cls(classes.container, loaded && classes.containerExpanded)}>
        <ul className={classes.categories} ref={listRef}>
          {related.map((category: RelatedCategoriesTargetModel) => (
            <RelatedCategory key={category.uid} {...category} />
          ))}
        </ul>
      </div>
      {!loaded && (
        <div className={classes.btnContainer}>
          <Button
            onClick={() => setLoaded(true)}
            size={ButtonSizeLG}
            variant={ButtonVariants.Filled}
            skin={ButtonSkinTertiary}
            data-pulse-name="Load more related categories"
          >
            {translate('Load more')}
          </Button>
        </div>
      )}
    </div>
  );
}
